import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import moment from 'moment';
import { handleStatus } from '../../../../shared/utils';
import { IResponseAjud } from '../../../../shared/services/types/response';
import Grid from '@mui/material/Grid';

interface CardAjudProps {
  ajudValue: IResponseAjud;
  handleOpenModal: (item?: IResponseAjud) => void;
}

const CardAjud = ({ ajudValue, handleOpenModal }: CardAjudProps) => {
  return (
    <>
      <Grid xs={12} sm={6} md={4} lg={2} key={ajudValue?.id}>
        <Card>
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="h6">Protocolo:</Typography>
              <Typography sx={{ fontSize: 12 }}>
                Reiteração:{' '}
                {ajudValue.type_record === '07'
                  ? ajudValue.reiteration_transference
                  : ajudValue.type_record === '05'
                    ? ajudValue.reiteration_unlock
                    : ajudValue.reiteration_block}
              </Typography>
            </Box>
            <Typography variant="h6" color="secondary.main">
              {ajudValue.court_order}
            </Typography>
            <Typography variant="body2">
              Data protocolização:{' '}
              {moment(ajudValue?.date_protocolization.slice(0, 8)).format(
                'DD/MM/yyyy',
              )}
            </Typography>
            <Typography mt={1} textAlign={'end'} variant="body2">
              <Box
                component="span"
                sx={{
                  display: 'inline-block',
                  px: 1.5,
                  py: 0.2,
                  borderRadius: 10,
                  fontSize: 12,
                  bgcolor:
                    handleStatus(ajudValue?.status) === 'Criado'
                      ? '#4CAF50' // Verde mais escuro
                      : handleStatus(ajudValue?.status) === 'Pendente'
                        ? '#FFC107' // Amarelo mais escuro
                        : '#BDBDBD', // Cinza médio
                  color: 'white',
                }}
              >
                {handleStatus(ajudValue?.status)}
              </Box>
            </Typography>
          </CardContent>
          <CardActions>
            <Button size="small" onClick={() => handleOpenModal()}>
              Detalhes
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </>
  );
};

export default CardAjud;
